import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface FilterSectionCheckboxFilterProps {
  headerSource: string
  checkboxProps: Array<{
    labelSource: string
    onChange: (checked: boolean) => void
    checked: boolean
  }>
}

const FilterSectionCheckboxFilter: React.FC<
  FilterSectionCheckboxFilterProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate(props.headerSource)}
      </div>
      {props.checkboxProps.map((checkboxProp, index) => (
        <Checkbox
          key={index + checkboxProp.labelSource}
          label={translate(checkboxProp.labelSource)}
          onClick={(): void => {
            checkboxProp.onChange(!checkboxProp.checked)
          }}
          isSelected={checkboxProp.checked}
        />
      ))}
    </div>
  )
}

export default FilterSectionCheckboxFilter
